__turbopack_context__.v({
  "average-container": "review-summary-widget-module-scss-module__wYjW3q__average-container",
  "average-number": "review-summary-widget-module-scss-module__wYjW3q__average-number",
  "average-rating-text": "review-summary-widget-module-scss-module__wYjW3q__average-rating-text",
  "average-rating-text-tooltip": "review-summary-widget-module-scss-module__wYjW3q__average-rating-text-tooltip",
  "average-stars": "review-summary-widget-module-scss-module__wYjW3q__average-stars",
  "disabled": "review-summary-widget-module-scss-module__wYjW3q__disabled",
  "inactive": "review-summary-widget-module-scss-module__wYjW3q__inactive",
  "percent-text": "review-summary-widget-module-scss-module__wYjW3q__percent-text",
  "rate-clear": "review-summary-widget-module-scss-module__wYjW3q__rate-clear",
  "rate-gauge": "review-summary-widget-module-scss-module__wYjW3q__rate-gauge",
  "rate-gauge--bg": "review-summary-widget-module-scss-module__wYjW3q__rate-gauge--bg",
  "rate-gauge--fill": "review-summary-widget-module-scss-module__wYjW3q__rate-gauge--fill",
  "rate-percent": "review-summary-widget-module-scss-module__wYjW3q__rate-percent",
  "rates": "review-summary-widget-module-scss-module__wYjW3q__rates",
  "rates-row": "review-summary-widget-module-scss-module__wYjW3q__rates-row",
  "rating-gauge-bar-container": "review-summary-widget-module-scss-module__wYjW3q__rating-gauge-bar-container",
  "rating-gauge-bar-content": "review-summary-widget-module-scss-module__wYjW3q__rating-gauge-bar-content",
  "rating-gauge-row": "review-summary-widget-module-scss-module__wYjW3q__rating-gauge-row",
  "rating-text": "review-summary-widget-module-scss-module__wYjW3q__rating-text",
  "stats-container": "review-summary-widget-module-scss-module__wYjW3q__stats-container",
  "with-average-rating": "review-summary-widget-module-scss-module__wYjW3q__with-average-rating",
});
